const getQuestionsData = (hasHydration) => [
    {
        title: "How much does Gainful cost?",
        body: [
            "The cost of your Gainful order is based on your personalized ingredients, plan frequency, and any add-on products. We calculate this price at the final step of checkout, and plans start at $45",
        ],
    },
    {
        title: "What is included in my order?",
        body: [
            "Your first Gainful order includes 2 bags of your personalized protein powder blend, a free supply of Gainful Flavor Boosts, and a custom-sized plastic scoop (inside bag).",
            `${hasHydration ? "We've also included Personalized Hydration in your Gainful system." : "You may also wish to add Personalized Hydration to your Gainful system."} The hydration comes as 21 Single-Serving Stick Packs and can be flavored Lemon-Lime or Strawberry Lemonade.`,
            "During checkout, you will also have the option of adding a Gainful BlenderBottle for just $8 – we promise this is the cheapest authentic BlenderBottle you’ll find.",
            "Lastly, you can also add a jar of Gainful Pre-Workout to your order starting at $22."
        ],
    },
    {
        title: "Is there a cancelation fee?",
        body: [
            "Never! You can delay, skip, or cancel your upcoming orders any time by logging into your profile. Our Customer Experience team is always available to answer your questions with a smile: hello@gainful.com",
        ],
    },
    {
        title: "Can I change the frequency of my orders?",
        body: [
            "Absolutely! Once you make your first purchase, you can reach out to our team at hello@gainful.com with any frequency requests – we promise we can make it work!",
        ],
    },
    {
        title: "Is the Hydration formula already flavored?",
        body: [
            "Yes! Unlike your Gainful protein powder, the Hydration supplement is already flavored. No need to add flavor boosts to it, although of course if you would like you can always include additional ingredients/flavors to your Hydration drink.",
        ],
    },
    {
        title: "Should I drink my Hydration formula on days that I don’t workout?",
        body: [
            "You can definitely consume your Hydration formula on days you don’t workout if you would like. Hydration is still a key component of your health and routine everyday. Even if you are not working out on a specific day, consuming enough fluids and electrolytes is very important.",
            "While the Hydration formula is most commonly consumed surrounding workouts, on non-workout days you could include it when you are most active, or simply anytime during the day. Otherwise though, it’s okay to only use your Hydration formula on days you exercise or are more active."
        ],
    },
    {
        title: "What is the difference between water vs. Hydration formula?",
        body: [
            "Maintaining proper hydration each day is vital as water is involved in every single process in the body. Because of this, you’ve likely heard a general recommendation to drink at least 8 cups of water a day. While consuming that recommended amount of water is a great way for the average person to stay on top of their hydration needs, there are instances where plain water isn’t enough. Hydration and rehydration depend not only on how much water you drink, but on the amount of water existing in your body from sweat, urination, and breathing.",
            "Your Hydration formula contributes to better and more efficient hydration than plain water can, as it contains a blend of electrolytes to replenish mineral losses from the above processes. It also contains a small amount of carbohydrates, which enhances sodium and water transport across the upper intestinal wall and into the bloodstream. In other words, a solution of water + glucose + salt hydrates better than water alone. This is especially true if you are exercising for more than 1 hour, you sweat heavily during exercise, or you are exposed to a hot environment for a long period of time. "
        ],
    },
];
export default getQuestionsData;
